import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-share-redirect',
  templateUrl: './share-redirect.component.html',
  styleUrls: ['./share-redirect.component.scss']
})
export class ShareRedirectComponent implements OnInit {

  constructor() { 
    window.close();
  }

  ngOnInit() {
  }

}
